import React from 'react'
import image from '../assets/announc.png'
const CarousalCard = () => {
  return (
    <div>
      <img src={image} className='max-w-[300px] ' alt="" />
    </div>
  )
}

export default CarousalCard
